
export class UserClaim {
    id: string;
    userId: string;
    claimType: string;
    claimValue: string;
}

export class User {
    
    id: string;
    isActive: boolean;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phoneNumber: string;
    associatedKioskIds: Array<string>;
    claims: Array<UserClaim>;

    getFullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }

    constructor() {

    }
}

export class TenantUser extends User {

    constructor(user: User) {
        super();
        
        this.associatedKioskIds = user.associatedKioskIds;
        this.email = user.email;
        this.firstName = user.firstName;
        this.id = user.id;
        this.isActive = user.isActive;
        this.lastName = user.lastName;
        this.password = user.password;
        this.phoneNumber = user.password;
        this.claims = user.claims;

    }

    //constructor(tenantId: string, isGlobalAdministrator: boolean, isTenantAdministrator: boolean) {
    //    super();
    //    this.tenantId = tenantId;
    //    this.isGlobalAdministrator = isGlobalAdministrator;
    //    this.isTenantAdministrator = isTenantAdministrator;
    //}

   

    tenantId: string;
    isGlobalAdministrator: boolean;
    isTenantAdministrator: boolean;
    autoConfirmUser: boolean;
    delayedKioskCloudSyncEmailRecipient: boolean;
    lowTicketStockEmailRecipient: boolean;
    lowBatteryVoltagEmailRecipient: boolean;
    declinedBatchTransactionsEmailRecipient: boolean;
    globalEmailRecipient: boolean;
}

